import React from "react";
import { CardHeader, Theme, Card, Grow, Badge } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import withStyles from "@mui/styles/withStyles";
import createStyles from "@mui/styles/createStyles";
import Alert from "./Alert";
import { useTranslation, Trans } from "react-i18next";

const useStyles = makeStyles((theme: Theme) => ({
	cardHeader: {
		backgroundColor: theme.palette.primary.main,
		color: "white",
		alignItems: "center",
		textAlign: "center",
	},
}));
const StyledBadge = withStyles((theme: Theme) =>
	createStyles({
		badge: {
			right: -12,
			top: 12,
			padding: "0 4px",
			border: `1.5px solid ${theme.palette.background.paper}`,
		},
	})
)(Badge);

export default function Alerts() {
	const [alerts, setAlerts] = React.useState<any>([
		{
			content: "This is an important Alert",
			severity: "error",
			id: 1,
		},
		{
			content: "This is an information Alert",
			severity: "info",
			id: 2,
		},
		{
			content: "This is a success Alert",
			severity: "success",
			id: 3,
		},
	]);
	const deleteAlert = (id: any) => {
		let remainingAlerts = alerts.filter((alert: any) => {
			return alert.id !== id;
		});
		setAlerts(remainingAlerts);
	};
	let renderedAlerts = alerts.map((alert: any) => (
		<Alert
			deleteAlert={deleteAlert}
			content={alert.content}
			severity={alert.severity}
			key={alert.id}
			id={alert.id}
		/>
	));
	const noAlerts = (
		<Alert content={"There are no new alerts at this time"} severity={"info"} sx={{ backgroundColor: "red" }} />
	);
	const classes = useStyles();
	useTranslation();
	return (
		<div style={{ paddingTop: 20, marginBottom: 20 }}>
			<Grow in={true} timeout={1000}>
				<Card raised={true}>
					<CardHeader
						className={classes.cardHeader}
						title={"Alerts"}
					/>
					<div>{noAlerts}</div>
				</Card>
			</Grow>
		</div>
	);
}
